import { Modal } from "antd"
import { kindMeta } from "./awardKinds"

const PLACE_LABEL = { 1: "1 місце", 2: "2 місце", 3: "3 місце" }

// antd Modal provides the shell + behaviour (Esc, scroll-lock, focus-trap,
// animations); the journal two-pane content and styling are ours. The scan/photo
// is shown large so diplomas are actually readable.
const AwardModal = ({ award, onClose }) => {
  const csrf = document.querySelector('meta[name="csrf-token"]')?.content
  const meta = award ? kindMeta(award.kind) : null

  return (
    <Modal
      open={Boolean(award)}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={860}
      className="book-modal"
      styles={{
        content: { padding: 0, overflow: "hidden", borderRadius: 10, background: "#f6efdd" },
        body: { padding: 0 },
        mask: { background: "rgba(60, 44, 30, 0.34)", backdropFilter: "blur(6px) saturate(108%)" },
      }}
    >
      {award && (
        <div className="modal__sheet">
          <div className="modal__visual">
            <div className="modal__polaroid">
              {award.photo_url ? (
                <img key={award.id} className="modal__cover" src={award.photo_large_url || award.photo_url} alt={award.direction_label} decoding="async" />
              ) : (
                <div className={`entry__photo entry__photo--blank award-blank award-blank--${award.kind}`}>
                  <i className={`fa-solid ${meta.icon} award-blank__icon`} aria-hidden="true"></i>
                  <span className="entry__blank-title">{award.direction_label}</span>
                </div>
              )}
              {award.place && (
                <span className={`award-place award-place--${award.place}`} aria-label={PLACE_LABEL[award.place]}>
                  {award.place}
                </span>
              )}
            </div>
          </div>

          <div className="modal__body">
            <button type="button" className="modal__close" onClick={onClose} aria-label="Закрити">
              ×
            </button>

            <h2 className="modal__title">{award.direction_label}</h2>
            <div className="modal__badges">
              <span className="modal__genre">
                <i className={`fa-solid ${meta.icon}`} aria-hidden="true"></i> {meta.one}
              </span>
              {award.place && (
                <span className={`modal__place award-place--${award.place}`}>{PLACE_LABEL[award.place]}</span>
              )}
            </div>

            <svg className="modal__rule" viewBox="0 0 220 12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M4 7 C 40 1, 60 11, 96 6 S 160 1, 216 6" />
            </svg>

            <dl className="modal__meta">
              <div>
                <dt>Додано до колекції</dt>
                <dd>{award.added_on}</dd>
              </div>
            </dl>

            <div className="modal__actions">
              <a className="btn" href={`/awards/${award.id}/edit`}>
                Редагувати
              </a>
              <form
                action={`/awards/${award.id}`}
                method="post"
                onSubmit={(event) => !confirm("Прибрати цю нагороду з колекції?") && event.preventDefault()}
              >
                <input type="hidden" name="_method" value="delete" />
                <input type="hidden" name="authenticity_token" value={csrf} />
                <button type="submit" className="btn btn-ghost">
                  Видалити
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </Modal>
  )
}

export default AwardModal
